import React from 'react';
import PepsodentGumExpertLogo from '../../../assets/periGum/pepsodent-gum-expert-logo.png';
import PeriPackShotTube from '../../../assets/periGum/peri-packshot-tube.png';
import buynowen from '../../../assets/periGum/buynow-en.png';
import learnmoren from '../../../assets/periGum/learnmore-en.png';
import consulten from '../../../assets/periGum/consult-en.png';
import buynowbs from '../../../assets/periGum/buynow-bs.png';
import learnmorbs from '../../../assets/periGum/learnmore-bs.png';
import consultbs from '../../../assets/periGum/consult-bs.png';
import buynowvn from '../../../assets/periGum/buynow-vn.png';
import learnmorevn from '../../../assets/periGum/learnmore-vn.png';
import consultvn from '../../../assets/periGum/consult-vn.png';

const LastPage = () => {
  const language = localStorage.getItem("userLanguage") || "en";
  let buyNowBtn, consultBtn, learnMoreBtn;
  let buyNowLink = null, consultLink = null, learnMoreLink = null;

  switch (language) {
    case "bs":
      buyNowBtn = buynowbs;
      consultBtn = consultbs;
      learnMoreBtn = learnmorbs;
      buyNowLink = "https://shop-id-pepsodent.com/Pepsodent-Gum-Expert-2024";
      consultLink = "https://www.tanyapepsodent.com/gum-analysis-tool.html";
      learnMoreLink = "https://www.tanyapepsodent.com/pepsodent-expert.html";
      break;

    case "vn":
      buyNowBtn = buynowvn;
      consultBtn = consultvn;
      learnMoreBtn = learnmorevn;
      buyNowLink = "https://www.psvietnam.vn/p/gum-expert-by-p-s.html/08934839135171";
      consultLink = "https://www.psvietnam.vn/tu-van-cung-chuyen-gia.html";
      learnMoreLink = "https://www.psvietnam.vn/pepsodent-expert.html";
      break;

    default:
      buyNowBtn = buynowen;
      consultBtn = consulten;
      learnMoreBtn = learnmoren;
  }

  const renderButton = (imgSrc, alt, link) => {
    if (link) {
      return (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <img src={imgSrc} alt={alt} className="w-20 h-20 object-contain" />
        </a>
      );
    }
    return <img src={imgSrc} alt={alt} className="w-20 h-20 object-contain" />;
  };

  return (
    <div className="min-h-screen flex flex-col relative bg-white">
      <div className="pt-14 text-right pb-10 pr-8">
        <img className="inline-block" src={PepsodentGumExpertLogo} alt="logo" />
      </div>
      <div className="flex-1 relative">
        <img
          src={PeriPackShotTube}
          alt="Packshot"
          className="mx-auto max-h-[80vh] object-contain"
        />
        <div className="absolute top-1/2 right-4 transform -translate-y-1/2 flex flex-col items-center gap-6">
          {renderButton(buyNowBtn, "Buy Now", buyNowLink)}
          {renderButton(consultBtn, "Consult", consultLink)}
          {renderButton(learnMoreBtn, "Learn More", learnMoreLink)}
        </div>
      </div>
    </div>
  );
};

export default LastPage;
